var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47368 0.220765C7.67496 0.221187 7.85919 0.333829 7.95131 0.512788L13.3704 11.0406C13.4592 11.2131 13.4483 11.42 13.342 11.5823C13.2356 11.7445 13.0502 11.837 12.8567 11.8244L8.41027 11.5347L8.6382 14.4949C8.65358 14.6946 8.55685 14.8863 8.38711 14.9926C8.21737 15.0989 8.00266 15.1022 7.82972 15.0012L4.10157 12.8233L1.21175 13.5818C1.00575 13.6359 0.787233 13.5635 0.654314 13.3971C0.521395 13.2307 0.499052 13.0015 0.597318 12.8126L6.99483 0.510787C7.0877 0.332215 7.2724 0.220344 7.47368 0.220765ZM7.87001 10.4203C7.8643 10.4199 7.85856 10.4195 7.85281 10.4192L7.38488 10.3887L7.61387 6.87333C7.63321 6.57658 7.40831 6.32034 7.11155 6.30101C6.8148 6.28168 6.55856 6.50657 6.53923 6.80333L6.27523 10.8561C6.2559 11.1528 6.4808 11.4091 6.77755 11.4284L7.32472 11.464L7.48556 13.5529L4.4522 11.7809C4.32889 11.7089 4.18201 11.6888 4.04388 11.725L2.11319 12.2318L7.4701 1.93099L11.9776 10.6879L7.87001 10.4203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeNow);
export default __webpack_public_path__ + "static/media/upgrade_now.cd967b7391d4199551388a08f40c4454.svg";
export { ForwardRef as ReactComponent };